import { Pipe, PipeTransform } from "@angular/core";


/**
 * @description To change achor tag target to blank.
 * @author Akhil
 * @date 2020-05-14
 * @export
 * @class ReplaceLinks
 * @implements {PipeTransform}
 */
@Pipe({
  name: "replaceLinks"
})

export class ReplaceLinks implements PipeTransform {
  transform(description: any): any {
    if (description && description.indexOf('<a href') > -1 && description.indexOf('target=_blank') === -1) {
      return description.replace(/href=/g, ' target=_blank href=');
    } else {
      return description;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/replace-links.pipe.ts